/* eslint-disable prefer-const */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { Typography, Grid, Snackbar } from '@material-ui/core/'
import MuiAlert from '@material-ui/lab/Alert'
import { useDispatch, useSelector } from 'react-redux'
import { setStep2 } from '../../../../modules/story/actions'
import { Button, Input, TooltipCustom } from '../../../../components/UI/'
import tooltipIcon from '../../../../assetss/img/tooltipIcon.svg'
import './index.scss'

const Alert = props => {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

const Step3 = () => {
  const [value, setValue] = useState('')
  const [error, setError] = useState()
  const history = useHistory()
  const dispatch = useDispatch()
  const { story } = useSelector(state => state)
  const { step2 } = useSelector(({ story }) => story)
  const [openAlert, setOpenAlert] = useState(false)
  const [open, setOpen] = useState(false)

  const handleTooltipOpen = () => setOpen(true)

  const goTo = path => history.push(path)

  const checkStoryText = () => {
    let data = new FormData()
    data.append('text', value)
    data.append('lang', 'en')
    data.append('opt_countries', 'us,gb,fr')
    data.append('mode', 'standard')
    data.append('api_user', '634621962')
    data.append('api_secret', '8RrfqoABbUfiJg7YHyn2')

    axios({
      url: 'https://api.sightengine.com/1.0/text/check.json',
      method: 'post',
      data: data,
      headers: { 'content-type': 'multipart/form-data' },
    })
      .then(({ data }) => {
        let filtered = data?.profanity?.matches?.filter(i => i?.type !== 'inappropriate' && i?.type !== 'other_profanity')
        if (filtered?.length) {
          filtered?.map(j => {
            setOpenAlert(true)
            setError('')
          })
        } else {
          dispatch(setStep2({ title: value }))
          goTo('/new-story/step/4')
          setError('')
          setValue('')
        }
      })
      .catch(function (error) {
        if (error?.response) console?.error(error?.response?.data)
        else console?.error(error?.message)
      })
  }

  const onNext = () => {
    if (!value) {
      setError('Please give your story a name.')
      return
    }

    if (error) {
      return
    }

    checkStoryText()
  }

  const onBackStep = () => {
    dispatch(setStep2({ title: value }))
    goTo('/new-story/step/2')
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenAlert(false)
  }

  useEffect(() => {
    setValue(story?.step2?.title)
  }, [story?.step2?.title])

  useEffect(() => {
    if (value?.length >= 60) {
      setError('Maximum number of characters')
    } else {
      setError('')
    }
  }, [value])

  useEffect(() => {
    if (value?.length > 1 && value?.length < 59) {
      setError('')
    }
  }, [value])

  useEffect(() => {
    if (step2?.title) {
      setValue(step2?.title)
    }
  }, [step2?.title])

  return (
    <>
      <Grid className='boxStep3'>
        <Snackbar
          open={openAlert}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        >
          <Alert onClose={handleClose} severity='error'>We’ve noticed you’re using unacceptable content that violates our terms of use.</Alert>
        </Snackbar>
        <Typography className='subTitle'>
          Write your story
        </Typography>
        <Typography className='stepTitle'>
          Give your story a name
          <TooltipCustom open={open} setOpen={setOpen}>
            <img className='tooltipIcon' src={tooltipIcon} alt='tooltipIcon' onClick={handleTooltipOpen} />
          </TooltipCustom>
        </Typography>
        <Input
          name='titleStory'
          id='titleStory'
          placeholder='Name story'
          type='text'
          value={value}
          customClass='inputCustom'
          onChange={e => setValue(e.target.value)}
          helperText={error}
          error={error}
          maxLength={62}
        />
        <Grid className='btnStepNameNewStore'>
          <Button className='prevBtn' onClick={onBackStep}>
            Previous step
          </Button>
          <Button className='nextBtn' onClick={onNext}>
            Next step
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

export default Step3
